<template>
  <div
    class="radar-chart"
    ref="radarChart"
    :style="{ width: chartSize.width, height: chartSize.height }"
  ></div>
</template>
  
<script>
import * as echarts from 'echarts';
// import { backgroundClip } from 'html2canvas/dist/types/css/property-descriptors/background-clip';

export default {
  props: {
    chartData: {
      required: false,
      default: [4200, 3000, 20000, 35000, 50000, 18000]
    },
    max: {
      required: false,
      default: 20000
    },
    chartSize: {
      type: Object,
      required: false,
      default: () => ({
        width: '400px',
        height: '400px'
      })
    },
    indicators: {
      type: Array,
      required: false,
      default: () => [
        { name: 'IQ', max: 20000 },
        { name: 'захист', max: 20000 },
        { name: 'фізика', max: 20000 },
        { name: 'швидкість', max: 20000 },
        { name: 'бачення', max: 20000 },
        { name: 'атака', max: 20000 },
        { name: 'техніка', max: 20000 }
      ]
    }
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      const chartDom = this.$refs.radarChart;
      const myChart = echarts.init(chartDom);
      const currentIndicators = this.indicators.map((indicator) => ({
        ...indicator,
        max: this.max
      }));
      const option = {
          radar: {
            radius: '65%',
            indicator: currentIndicators,
            axisName: {
              textStyle: {
                fontSize: 10,
                distance: 5,
                color: '#474849',
              }
            },
            splitArea: {
              show: true,
              areaStyle: {
                color: [
                  '#FA136788',
                  '#FA136788',
                  '#E4F94E88',
                  '#41BF7488',
                  '#41BF7488',
                  '#41BF7488'
                ]
              }
            },
            splitLine: {
              lineStyle: {
                color: '#BDBDBD33' // синие кольцевые линии
              }
            },
            axisLine: {
              lineStyle: {
                color: '#BDBDBD',
                width: 0 // толщина оси
              }
            }
          },
          series: [
            {
              name: 'Budget vs spending',
              type: 'radar',
              data: [
                {
                  value: this.chartData,
                  name: 'Allocated Budget',
                  areaStyle: {
                    color: 'rgba(197, 144, 20, 0.8)' // цвет заливки (прозрачный)
                  },
                  lineStyle: {
                    color: 'rgba(71, 72, 73, 1)', // цвет линии
                    width: 4 // толщина линии
                  },
                  itemStyle: {
                    color: 'rgba(71, 72, 73, 1)' // цвет точек
                  }
                }
              ]
            }
          ],
      };
      myChart.setOption(option);
      window.addEventListener('resize', this.updateChartSize(myChart));
    },
    updateChartSize(chart) {
      if (chart) chart.resize();
    }
  }
};
</script>

<style scoped>
/* Здесь можно добавить стили, если нужно */
</style>
